// Wallet
export const ClientNotExistError = new Error('Client Not Exist!');
export const RejectedError = new Error('Request Rejected!');
// QRCode
export const ExpiredError = new Error('Expired!');
//# sourceMappingURL=error.js.map